import { useContext } from "react";
import {
  viewerFile,
  viewerClean,
  viewerLoad,
  ViewerContext,
  viewerView,
} from "../contexts/viewer";

function useViewer() {
  const { viewerState, viewerDispatch } = useContext(ViewerContext);

  const viewerLoading = () => {
    viewerLoad(viewerDispatch).then();
  };

  const viewerChildren = (view) => {
    viewerView(viewerDispatch, view).then();
  };

  const viewer = (file, mimeType) => {
    viewerFile(viewerDispatch, file, mimeType).then();
  };

  const viewerClose = () => {
    viewerClean(viewerDispatch).then();
  };

  return {
    viewerChildren,
    viewerLoading,
    viewer,
    viewerClose,
  };
}

export default useViewer;
